export default "__VITE_ASSET__D7jvkwA0__"